import { render, staticRenderFns } from "./promotionalPage.vue?vue&type=template&id=02ebe514&scoped=true"
import script from "./promotionalPage.vue?vue&type=script&lang=js"
export * from "./promotionalPage.vue?vue&type=script&lang=js"
import style0 from "./promotionalPage.vue?vue&type=style&index=0&id=02ebe514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ebe514",
  null
  
)

export default component.exports